import AvidLogo from './img/avid-logo-blue-noborder.png';

const LogoNoBorder = ({ height = 28 }: { height?: number }) => {
  return <img src={AvidLogo} alt="AvidXchange" height={height} />;
};

export default LogoNoBorder;
